import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

/* if the route is private and the user is logged in, render the component 
otherwise render <Navigate> to redirectTo */

export const PrivateRoute = ({ component: Component, redirectTo = "/" }) => {
    const { isLoggedIn, isRefreshing } = useAuth();
    const shouldRedirect = !isLoggedIn && !isRefreshing;

    return shouldRedirect ? <Navigate to={redirectTo} /> : Component;
};